import { config } from './config';

const CALLBACK = '__ethrhuntMapsReady';

let loading: Promise<void> | null = null;

/**
 * Loads the Google Maps JavaScript API once per page. Rejects, and adds no script, when there
 * is no key. A failed load is forgotten so a later call tries again.
 */
export function loadGoogleMaps(): Promise<void> {
  if (loading) return loading;
  const key = config.googleMaps.apiKey;
  if (key === '') return Promise.reject(new Error('Google Maps is not configured'));

  const attempt = new Promise<void>((resolve, reject) => {
    const w = window as unknown as Record<string, unknown>;
    const script = document.createElement('script');
    w[CALLBACK] = () => {
      delete w[CALLBACK];
      resolve();
    };
    script.async = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&v=weekly&loading=async&callback=${CALLBACK}`;
    script.addEventListener('error', () => {
      delete w[CALLBACK];
      script.remove();
      reject(new Error('Google Maps failed to load'));
    });
    document.head.append(script);
  });
  loading = attempt;
  attempt.catch(() => {
    if (loading === attempt) loading = null;
  });
  return attempt;
}

/** Test hook: forget a cached load. */
export function resetGoogleMapsLoader(): void {
  loading = null;
}
